import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid2,
  IconButton,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { formatPhone } from "../helpers/format";
import Loading from "./Loading";
import Gympass from "../assets/svg/gympass.svg";
import { gympassCheckIn } from "../services/gympass";

const ConfirmCheckIn = ({
  open,
  onClose,
  data,
  refetch,
}: {
  open: boolean;
  onClose: () => void;
  data: {
    id: string;
    name: string;
    email: string;
    phone: string;
  };
  refetch?: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: gympassCheckIn,
    onSuccess: () => {
      onClose();
      toast.success("Check-in confirmado com sucesso!");

      if (refetch) refetch();
    },
    onError: (e: any) => {
      onClose();
      if (refetch) refetch();

      toast.error(
        e?.response?.data?.message ||
          "Não conseguimos validar o check-in do Gympass"
      );
    },
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <Loading loading={isPending} />
      <DialogContent>
        <Grid2 container spacing={2}>
          <Grid2 size={12}>
            <Stack
              display="flex"
              flexDirection={"row"}
              width={"100%"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Stack>
                <img src={Gympass} style={{ width: "140px" }} />
              </Stack>

              <IconButton onClick={onClose}>
                <IconX />
              </IconButton>
            </Stack>
          </Grid2>

          <Grid2 size={12}>
            <Stack
              padding={"0.5rem"}
              sx={{ backgroundColor: "#161616", borderRadius: "1rem" }}
              flexDirection={"row"}
              gap="1rem"
              alignItems={"center"}
            >
              <Stack padding={"0.3rem"}>
                <Typography>
                  <strong>Nome:</strong> {data?.name}
                </Typography>
                <Typography>
                  <strong>Email:</strong> {data?.email}
                </Typography>
                <Typography>
                  <strong>Telefone:</strong> {formatPhone(data?.phone)}
                </Typography>
              </Stack>{" "}
            </Stack>{" "}
          </Grid2>
        </Grid2>
      </DialogContent>

      <DialogActions>
        <Stack width={"100%"} gap={2}>
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={() => {
              mutate(data);
            }}
            disabled={isPending}
            color="success"
          >
            Confirmar Check-in
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmCheckIn;
